import React from "react";

const SvgCar = ({ color = "currentColor", ...props }) => (
  <svg width="18" viewBox="0 0 18 18" {...props}>
    <path
      d="M18.007 8.113a.9.9 0 0 0-.9-.9h-1.673l-.809-5.654A1.8 1.8 0 0 0 12.841.013H5.155a1.8 1.8 0 0 0-1.784 1.546l-.809 5.654H.889a.9.9 0 0 0-.9.9.9.9 0 0 0 .9.9H2.3l-.257 1.8h-.258a1.8 1.8 0 0 0-1.8 1.8v1.8a1.8 1.8 0 0 0 1.8 1.8v.9a.9.9 0 0 0 .9.9h1.8a.9.9 0 0 0 .9-.9v-.9H12.6v.9a.9.9 0 0 0 .9.9h1.8a.9.9 0 0 0 .9-.9v-.9a1.8 1.8 0 0 0 1.8-1.8v-1.8a1.8 1.8 0 0 0-1.8-1.8h-.257l-.258-1.8h1.416a.9.9 0 0 0 .906-.9zm-12.071-6.3h6.123a.9.9 0 0 1 .892.773l1.177 8.226H3.867l1.177-8.226a.9.9 0 0 1 .892-.773zm7.566 10.8a.9.9 0 0 1 .9.9.9.9 0 0 1-.9.9.9.9 0 0 1-.9-.9.9.9 0 0 1 .898-.9zm-9.01 1.8a.9.9 0 0 1-.9-.9.9.9 0 0 1 .9-.9.9.9 0 0 1 .9.9.9.9 0 0 1-.9.899z"
      fill={color}
      fillRule="evenodd"
    />
  </svg>
);

export default SvgCar;
